import React from 'react';
import cn from 'classnames';

import {IModuleMediaProps} from './IModuleMedia';

import styles from './ModuleMedia.module.scss';

const ModuleMedia = ({children, classNames}: IModuleMediaProps) => {
	return <div className={cn(styles['module__media'], classNames, 'module__media')}>{children}</div>;
};

export default ModuleMedia;
